@if (isUrl) {
  <a rel="noopener noreferrer" target="_blank" [href]="url">{{ url }}</a>
} @else {
  <span>{{ url }}</span>
}
